import { Form } from 'antd';
import React from 'react';

function Register() {
	return <Form></Form>;
}

export default Register;
